var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 11.7376C14.6682 11.7376 16.8316 9.11006 16.8316 5.86882C16.8316 2.62752 16.1213 0 11.9999 0C7.87837 0 7.16797 2.62752 7.16797 5.86882C7.16797 9.11006 9.33133 11.7376 11.9999 11.7376Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.127 20.8529C21.1278 20.4775 21.1296 20.7988 21.127 20.8529V20.8529Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1149 20.4615C21.0254 14.8152 20.288 13.2063 14.645 12.1879C14.645 12.1879 13.8507 13.2 11.9993 13.2C10.1479 13.2 9.35339 12.1879 9.35339 12.1879C3.77202 13.1952 2.98976 14.7802 2.8869 20.2781C2.87846 20.727 2.87456 20.7506 2.87305 20.6985C2.87339 20.7961 2.8738 20.9767 2.8738 21.2917C2.8738 21.2917 4.21725 24 11.9993 24C19.7812 24 21.1248 21.2917 21.1248 21.2917C21.1248 21.0893 21.1249 20.9486 21.1251 20.8529C21.1236 20.8851 21.1206 20.8227 21.1149 20.4615Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManUser);
export default __webpack_public_path__ + "static/media/man-user.d57f92d508f6fb26613ad2a996a5c97d.svg";
export { ForwardRef as ReactComponent };